export default __webpack_public_path__ + "static/media/eric_full.164c60dc.png";